module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av570-7ed37b8a0599cfad6087e8469d03cb47.jpg";